/**
 * hydrator
 * hydrate method
 * Can be different in different types of inputs
 * For radios, select and checkboxes optionsHydrator is used
 */
export default {
  created() {
    if (this.hydrate && this.hydrator) {
      this.hydrator()
    }
  }
}
